/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 19.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import BaseContainer from "../../../../containers/BaseContainer";
import {NotificationStore} from "../../../../services/Notification";
import NavbarNotifications from "./NavbarNotifications";

class NavbarNotificationsContainer extends BaseContainer {
    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
        super(props, {
            notification: NotificationStore
        });
    }

    render() {
        return (
            <NavbarNotifications notifications={this.state.notification.data} />
        );
    }
}

export default NavbarNotificationsContainer;
